import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import reviewers from './reviewers.json';
import reviewersBooster from './reviewers-booster.json';
import {UserSubscription, UserSubscriptionType} from "../../../../../../user/user-subscription";

@Component({
    selector: 'db-paid-feature-upgrade-banner',
    templateUrl: './paid-feature-upgrade-banner.component.html',
    styleUrls: ['./paid-feature-upgrade-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PaidFeatureUpgradeBannerComponent implements OnInit {
  protected readonly Number = Number;
  @Input() expirationDate: Date | string;
  @Input() boosterPro: boolean;
  @Input() userSubscription: UserSubscription;
  public userSubscriptionTypes = UserSubscriptionType;
  public reviewers: any[];

  constructor() { }

  ngOnInit() {
    !!this.boosterPro ? this.reviewers = reviewersBooster : this.reviewers = reviewers;
  }
}
